// Views - Pages
import Page404 from '@/views/pages/Page404';
import Page500 from '@/views/pages/Page500';
import Login from '@/views/pages/Login';
import ForgetPasswd from '../views/pages/ForgetPasswd';
import Browse from '@/views/browse/tms';

const route = [
  {
    path: '/',
    redirect: '/browse',
    name: 'tms_h5',
    component: {
      render(c) { return c('router-view') },
    },
    children: [
      {
        path: '/browse',
        name: 'tms首页',
        component: Browse,
        meta: {
          page_id: '0000',
        },
      },
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render(c) { return c('router-view') },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: Page404,
      },
      {
        path: '500',
        name: 'Page500',
        component: Page500,
      },
      {
        path: 'login',
        name: 'Login',
        component: Login,
      },
      {
        path: 'modifypasswd',
        name: 'ForgetPasswd',
        component: ForgetPasswd,
      },
    ],
  },
  {
    path: '*',
    redirect: { path: '/browse' },
  },
];

export default route;
